import { NgModule } from '@angular/core';
import { SwipesumHeaderComponent } from './swipesum-header.component';

@NgModule({
    declarations: [SwipesumHeaderComponent],
    exports: [SwipesumHeaderComponent]
})
export class AppHeaderModule {
}